/**
 * Converts a list of [key, value] pairs to an object
 * @param list a list of [key, value] pairs
 * @returns an object with the keys and values from the list
 */
export default function listToObject<T>(list: [string, T][]): { [key: string]: T } {
  return list.reduce((acc, [key, value]) => {
    acc[key] = value
    return acc
  }, {} as { [key: string]: T })
}
